import React from "react"
import TwitterBot from "./TwitterBot"
import NewsletterBot from "./NewsletterBot"

const BotsControl = () => {
  return (
    <div className="px-9 py-8 flex flex-col gap-5">
      <header className="mb-3">
        <h1 className="font-semibold text-3xl text-left">Bots control</h1>
      </header>
      <TwitterBot />
      <NewsletterBot />
    </div>
  )
}

export default BotsControl
